import classNames from "classnames";
import Link, { LinkProps } from "../Link/Link";
import React from "react";
import styles from "./LinkOverlay.module.scss";

export interface LinkOverlayProps<T> extends LinkProps<T> {}

/**
 * Needs a position: relative ancestor which it will fill with the overlay.
 *
 * Consider LinkOverlayContainer for special handling of other links.
 */
const LinkOverlay = <T,>({ className, ...rest }: LinkOverlayProps<T>) => {
  return <Link {...rest} className={classNames(className, styles.overlay)} />;
};

export default LinkOverlay;
